// src/utils/rentalProductAdapter.js

/**
 * Adapteri, joka muuntaa oman API:n product-olion
 * Rental-näkymän odottamaan muotoon.
 *
 * KATEGORIAT:
 * 1 = Äänentoisto
 * 2 = Valot / esitystekniikka
 * 3 = Muut
 */

/**
 * YKSI TOTUUS: mitä kuuluu mihinkin
 * 👉 muuta tätä, jos kategoriat muuttuvat
 */
const CATEGORY_BY_SLUG = {
  // === ÄÄNENTOISTO (1) ===
  "2000w-aanentoistopaketti": 1,
  "300w-aanentoistopaketti": 1,
  "625w-aanentoistopaketti": 1,
  "lavamonitori-db-fm12-600w": 1,
  "jbl-partybox-300-240w-mikrofoneilla": 1,
  "mikseri-soundcraft-fx16": 1,

  // === VALOT / ESITYSTEKNIIKKA (2) ===
  "adj-stinger-spot-30": 2,
  "led-valot-chauvet-56-24c": 2,
  "langaton-dmx-ohjain-adj-my-dmxgo": 2,
  "multiefekti-valo-adj-stinger-ii": 2,
  "savukone-adj-volcano": 2,

  // === MUUT (3) ===
  "fujifilm-instax-mini-12": 3,
  "ikrofoni": 3,
  "ikrofoniteline": 3,
};

/**
 * API:n media-base
 * 🔑 yksi paikka, ei kovakoodausta komponenteissa
 */
const API_BASE_URL = "https://spiderlegsproductions.com";

function toAbsUrl(maybePath) {
  if (!maybePath) return "";
  const s = String(maybePath);
  return s.startsWith("http") ? s : `${API_BASE_URL}${s}`;
}

export function adaptRentalProduct(apiItem) {
  const slug = String(apiItem?.slug || "").toLowerCase();
  const kategoriaID = CATEGORY_BY_SLUG[slug] ?? 3;
  const stock = Number(apiItem?.stock ?? 0);

  const price = Number(
    apiItem?.pricing?.unitPrice ??
    apiItem?.price ??
    apiItem?.price_per_day ??
    0
  );

  // 🔎 DEV-AIKAINEN VAROITUS – EI VAIKUTA PROD
  if (
    process.env.NODE_ENV === "development" &&
    !Number.isFinite(price)
  ) {
    console.warn("⚠️ Tuotteelta puuttuu tai on virheellinen hinta:", apiItem);
  }

  // API voi palauttaa images[] objekteja muodossa:
  // { alt, url, order }  TAI  { alt_text, image_url, sort_order }
  const rawImages = Array.isArray(apiItem?.images) ? apiItem.images : [];

  const normalizedImages =
    rawImages.length > 0
      ? rawImages
          .map((img, idx) => {
            const rawUrl = img?.image_url ?? img?.url ?? "";
            const absUrl = toAbsUrl(rawUrl);

            // Jos url puuttuu kokonaan, skipataan kuva
            if (!absUrl) return null;

            return {
              ...img,
              image_id: img?.image_id ?? `img-${idx}`,
              image_url: absUrl,
              alt_text: img?.alt_text ?? img?.alt ?? apiItem?.primary_image_alt ?? apiItem?.name ?? "",
              sort_order: Number(img?.sort_order ?? img?.order ?? idx),
            };
          })
          .filter(Boolean)
      : [];

  const primaryAbs = toAbsUrl(apiItem?.primary_image_url);

  // Jos images[] puuttuu, tehdään fallback primary-kuvasta
  const images =
    normalizedImages.length > 0
      ? normalizedImages
      : primaryAbs
        ? [
            {
              image_id: "primary",
              image_url: primaryAbs,
              alt_text: apiItem?.primary_image_alt || apiItem?.name || "",
              sort_order: 0,
            },
          ]
        : [];

  return {
    ...apiItem,

    id: Number(apiItem?.id),
    name: apiItem?.name,
    slug,

    price,

    image: primaryAbs || "/images/placeholder-rental.jpg",

    images,

    kategoriaID, // 🔥 TÄMÄ on syy miksi listaus toimii

    available: stock,
    isBooked: stock <= 0,

    link: `/tuote/${slug}`,
    _source: "api-products",
  };
}
